import Axios from 'axios'
import store from '@/store'
import router from '@/router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { notification } from 'ant-design-vue'
// 引入许可证激活组件
import license from '@/components/common/License'
/*  页面进度条加载动画
    全局配置
 */

NProgress.configure({ easing: 'ease', speed: 1000 });

/*  Axios
    全局设置
 */

// 请求超时时长
Axios.defaults.timeout = process.env.NODE_ENV === 'production' ? window.env.AJAX_TIMEOUT : process.env.VUE_APP_AJAX_TIMEOUT

//API请求主域
Axios.defaults.baseURL = (process.env.NODE_ENV === 'production' ? window.env.API_BASE_URL : process.env.VUE_APP_BASE_URL)

//请求拦截器
Axios.interceptors.request.use((config) => {

  // 请求时开始加载进度条动画
  NProgress.start()

  // 请求头添加带上Access token
  config.headers['Authorization'] = store.state.user.token        

  return config

}, (err) => {

  return Promise.reject(err)

})

//响应拦截器

Axios.interceptors.response.use((res) => {

  let interceptCodes = JSON.parse(sessionStorage.getItem('interceptCodes')) || []     // 已弹窗CODE集合，处理重复弹窗的问题
  console.log(res.data.code)
  // 响应成功结束加载进度条动画
  NProgress.done()
  // 根据响应数据的code值来显示不同的提示信息
  switch (res.data.code) {

    case 401:
      if (!interceptCodes.includes(401)) {
        interceptCodes.push(401)
        sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
        if(store.state.user.token){
          notification.warning({
            message: '登录过期',
            description: '登录超时或用户状态过期，请重新登录!',
            duration: 3,
            onClose(){
              interceptCodes = interceptCodes.filter(i=>{return i!=401})
              sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
            },
          });
          store.commit('user/logout')
        }
      }
      router.push('/login')
      break;

    case 403:
      // notification.warning({
      //   message: '权限过期',
      //   description: '当前用户无该操作权限，请联系管理员！'
      // })
      router.push('/no-permission')
      break;
    case 400:
      if (!interceptCodes.includes(400)) {
        interceptCodes.push(400)
        sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
        notification.warning({
          message:res.data.message,
          duration: 3,
          customClass: "batch-import",
          onClose(){
            interceptCodes = interceptCodes.filter(i=>{return i!=400})
            sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
          },
        })
      }
      break;
    case 500:
      console.log(interceptCodes)
      if (!interceptCodes.includes(500)) {
        interceptCodes.push(500)
        sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
        if (res.data.message) {
          notification.warning({
            message:res.data.message,
            duration: 3,
            customClass: "batch-import",
            onClose(){
              interceptCodes = interceptCodes.filter(i=>{return i!=500})
              sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
            },
          })
        } else {
          notification.error({
            message: '系统错误',
            duration: 3,
            description: '系统内部错误，请联系管理员！',
            onClose(){
              interceptCodes = interceptCodes.filter(i=>{return i!=500})
              sessionStorage.setItem('interceptCodes', JSON.stringify(interceptCodes))
            },
          })
        }
      }
      break;
  }

  return res.data

}, (error) => {
  let errorCodes = JSON.parse(sessionStorage.getItem('errorCodes')) || []     // 已弹窗CODE集合，处理重复弹窗的问题
  // 响应错误关闭加载进度条动画
  NProgress.done()
  // 判断许可证过期状态
  if (error.response.status == 423){
    // 424已过期  426未授权
    switch (error.response.data.code) {
      case 426:
        if (!errorCodes.includes(426)) {
          errorCodes.push(426)
          sessionStorage.setItem('errorCodes', JSON.stringify(errorCodes))
          license({modalVisible:true,closableReset:false});  // 许可证弹出框
          notification.warning({
            message: '警告',
            duration: 3,
            description: error.response.data.message,
            customClass: "batch-import",
            onClose(){
              errorCodes = errorCodes.filter(i=>{return i!=426})
              sessionStorage.setItem('errorCodes', JSON.stringify(errorCodes))
            },
          })
        }
        break;
      case 424:
        if (!errorCodes.includes(424)) {
          errorCodes.push(424)
          sessionStorage.setItem('errorCodes', JSON.stringify(errorCodes))
          license({modalVisible:true,closableReset:false});  // 许可证弹出框
          notification.warning({
            message: '警告',
            duration: 3,
            description: error.response.data.message,
            customClass: "batch-import",
            onClose(){
              errorCodes = errorCodes.filter(i=>{return i!=424})
              sessionStorage.setItem('errorCodes', JSON.stringify(errorCodes))
            },
          })
        }
        break;
    }
  }else{
    // 响应错误信息提示
    notification.error({
      message: error.response ? '服务器错误' : '网络错误',
      description: error.response ? '服务器无响应，请稍后再试！（status:'+error.response.status+'）' : ('网络请求超时，请稍后再试！（Msg：'+error.message+'；Api：'+error.config.url+'）')
    })
  }


  return Promise.reject(error.message)

})

export default Axios